<template>
  <section class="footer">
    <Acorn
      :width="36"
      :height="36"/>
    <div class="actions">
      <BLink
        class="contact-link"
        href="mailto:info@talloaks.io">
        toer@talloaks.io
      </BLink>
      <BLink
        class="contact-link"
        href="phone:5039156336">
        (503) 915-6336
      </BLink>
    </div>
    <!-- <div class="container-fluid"> -->
    <!--   <div class="row"> -->
    <!--     <div class="col-md-6 col-xl-8"> -->
    <!--       <p><img -->
    <!--         src="@/assets/acornalone@4x.png" -->
    <!--         class="footer-logo" -->
    <!--         alt="talloaks logo" ></p> -->
    <!--       <small>Tall Oaks Copyright 2018, all rights reserved.</small> -->
    <!--       <div class="spacer-sm"/> -->
    <!--     </div> -->
    <!--     <div class="menu col"> -->
    <!--       <p class="font-bold text-caps">Contact</p> -->
    <!--       <ul class="plain-list links"> -->
    <!--         <li><a href="mailto:toer@talloaks.io">toer@talloaks.io</a></li> -->
    <!--         <li><a href="tel:5039156336">(503) 915 6336</a></li> -->
    <!--       </ul> -->
    <!--     </div> -->
    <!--     <div class="menu col"> -->
    <!--       <p class="font-bold text-caps">Connect</p> -->
    <!--       <ul class="plain-list links"> -->
    <!--         <li><a -->
    <!--           href="https://www.linkedin.com/company/talloaks-environmentalresearch/" -->
    <!--           target="_blank">LinkedIn</a></li> -->
    <!--           <\!-- <li><a href="#">Instagram</a></li> -\-> -->
    <!--       </ul> -->
    <!--     </div> -->
    <!--     <div class="menu col"> -->
    <!--       <p class="font-bold text-caps">Website</p> -->
    <!--       <ul class="plain-list links"> -->
    <!--         <li><router-link to="/#about">About</router-link></li> -->
    <!--         <\!-- <li><router-link to="/services">Services</router-link></li> -\-> -->
    <!--         <li><router-link to="/#services">Services</router-link></li> -->
    <!--         <li><router-link to="/contact">Contact Us</router-link></li> -->
    <!--       </ul> -->
    <!--     </div> -->
    <!--   </div> -->
    <!-- </div> -->
  </section>
</template>

<script>
import Acorn from './Acorn';
import { BLink } from 'bootstrap-vue';

export default {
  name: 'Footer',
  props: { },
  components: {
    Acorn,
    'b-link': BLink,
  }
};

</script>

<style lang="scss">
@import '~@/styles/variables';

.footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: darken($footer-color, 5%);
  color: $page-color;
  padding: 1rem;

  .actions {
    margin-left: auto;
    .contact-link {
      font-color: white;
      margin-right: 2rem;
    }
  }
}


</style>
